<template>
    <div class="login">
        <div class="columns">
            <div class='column is-4 is-offset-4'>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <form>
                    <div class='column is-horizontal-center top-logo'>
                          <figure class='image'>
                            <img src="../../assets/images/lango.png">
                        </figure>
                    </div>
                    <div v-show="! showSuccessMessage">
                        <div class="password-reset">
                            <p class="reset-heading">Account Recovery</p>
                            <p>A reset link will be sent to the account email.</p>
                        </div>
                        <div class="field" style="margin-top: 25px;">
                            <div class="control has-icons-left">
                                <input class="input is-medium" v-bind:class="{ 'is-danger': usernameErr }" type="text" placeholder="Account Email" v-model="username" @focus="clearErrorMsgs">
                                <span class="icon is-small is-left">
                                    <icon name="user"></icon>
                                </span>
                            </div>
                            <p v-if="usernameErr" class="help is-danger is-danger-username">Username is required</p>
                            <p v-if="showUserNotFound" class="help is-danger is-danger-username">{{userNotFoundMessage}}</p>
                        </div>
                        <div class="field" style="margin-top: 25px;">
                            <button @click.prevent="checkUsername" class="button is-link login-link" v-bind:class="{ 'is-loading': isLoading}">Submit</button>
                        </div>
                        <div class="field">
                            <div class="password-reset">
                                <p class="back-to-login" @click="returnToLogin">Back to Login</p>
                            </div>
                        </div>
                    </div>
                    <div v-show="showSuccessMessage">
                        <div class="password-reset">
                            <p><img src="../../assets/images/success.png" style="margin-bottom: 16px;"></p>
                            <p class="reset-heading">Password Reset Email Sent</p>
                            <p>A password reset link has been sent to the email associated with your account. Please check your inbox and follow the instructions.
                            </p>
                        </div>
                        <div class="field" style="margin-top: 25px;">
                            <div class="password-reset">
                                <span class="back-to-login button is-link login-link" @click="returnToLogin">Back to Login</span>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    data () {
        return {
            username: '',
        }
    },

    computed: {
        ...mapState('forgotPassword', {
            isLoading: state => state.isLoading,
            usernameErr: state => state.usernameErr,
            userNotFoundErr: state => state.userNotFoundErr,
            showSuccessMessage: state => state.showSuccessMessage,
            successMessage: state => state.successMessage,
            showUserNotFound: state => state.showUserNotFound,
            userNotFoundMessage: state => state.userNotFoundMessage,
        })
    },

    methods: {
        checkUsername(){
            var thisLogin = this;

            if(_.trim(thisLogin.username) === ''){
                VueStore.dispatch('forgotPassword/setBoolean', {key: 'usernameErr', bool: true});
            } else {
                VueStore.dispatch('forgotPassword/setBoolean', {key: 'isLoading', bool: true});
                var user = {
                    username: thisLogin.username
                }

                VueStore.dispatch('forgotPassword/forgotPassword', user);
            }
        },

        returnToLogin(){
            window.location.href = '/login';
        },

        clearErrorMsgs(){
            VueStore.dispatch('forgotPassword/setBoolean', {key: 'usernameErr', bool: false});
        },

        fetchData(){
            // this will save the url of client
            VueStore.dispatch('global/getBaseURL');
        }
    },

    mounted(){
        this.fetchData();
        // retrive environment variables and stored in vuex.
        VueStore.dispatch('auth/setVariables');
    }
}
</script>

<style>
</style>
